import React from "react";
import { shortenParagraph } from "../../../../utils/Engagement";
import { formatSeconds } from "../../../../utils/helper";
export default function Overview({ data, book, chapter }) {
  function formatDate(inputDate) {
    if (!inputDate) return "--";
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  const title = data?.fileInfo?.fileName ?? "--";
  const description = data.contentDescription ?? "--";
  const author = data?.fileInfo?.author_name ?? "--";
  return (
    <div>
      <div className="flex gap-3 items-center">
        <div className="video_titles mt-2 flex">Title:</div>
        {data !== undefined ? (
          <div className="Video_header_detail" title={title}>{shortenParagraph(title, 30)}</div>
        ) : (
          <div className="Video_header_detail">No Information.</div>
        )}
      </div>
      <div className="flex gap-4 items-center">
        <div className="video_titles">Description:</div>
        {data !== undefined ? (
          <div className="Video_header_detail" title={description}>{shortenParagraph(description, 30)}</div>
        ) : (
          <div className="Video_header_detail">No Information.</div>
        )}
      </div>
      {/* <div className="video_titles">File Size</div>
      {data !== undefined ? (
        <div className="Video_header_detail">{data?.fileInfo?.fileSize}</div>
      ) : (
        <div className="Video_header_detail">No Information.</div>
      )} */}
      <div className="flex gap-4 items-center">
        <div className="video_titles flex">Content Length & Type: </div>
        {/* {data !== undefined ? (
        <div className="Video_header_detail">
          {data?.fileInfo?.fileLength}{" "}
          {data?.fileInfo?.fileType === "audio" ||
            data?.fileInfo?.fileType === "video" ||
            data?.fileInfo?.fileType === "mp4" ||
            data?.fileInfo?.fileType === "mp3"
            ? "minutes"
            : "pages"}{" "}
          • {data?.fileInfo?.fileType}
        </div>
      ) : (
        <div className="Video_header_detail">No Information.</div>
      )} */}
        {data !== undefined ? (
          <div className="Video_header_detail">
            {
              data?.fileInfo?.fileType === "e-book"
                ? data?.fileInfo?.fileLength
                : data?.fileInfo?.fileType === "audio" ||
                  data?.fileInfo?.fileType === "video" ||
                  data?.fileInfo?.fileType === "mp4" ||
                  data?.fileInfo?.fileType === "mp3"
                  ? formatSeconds(data?.fileInfo?.fileLength)
                  : data?.fileInfo?.fileLength
            }{" "}
            {
              data?.fileInfo?.fileType === "audio" ||
                data?.fileInfo?.fileType === "video" ||
                data?.fileInfo?.fileType === "mp4" ||
                data?.fileInfo?.fileType === "mp3"
                ? ""
                : "pages"
            }{" "}
            • {data?.fileInfo?.fileType}
          </div>
        ) : (
          <div className="Video_header_detail">No Information.</div>
        )}
      </div>
      <div className="flex gap-4 items-center">
        <div className="video_titles">Posted on: </div>
        {data !== undefined ? (
          <div className="">
            {
              <div className="Video_header_detail">
                {formatDate(data?.fileInfo?.filePostedTime)}
              </div>
            }
          </div>
        ) : (
          <div className="Video_header_detail">No Information.</div>
        )}
      </div>
      <div className="flex gap-4 items-center">
        <div className="video_titles">Chapter & Book:</div>
        <div className="Video_header_detail">
          {chapter} of {book}
        </div>
      </div>
      <div className="flex gap-3 items-center">
        <div className="video_titles">Author Name:</div>
        {data !== undefined ? (
          <div className="Video_header_detail" title={author}>{author}</div>
        ) : (
          <div className="Video_header_detail">No Information.</div>
        )}
      </div>
    </div>
  );
}
